/**
 * @license
 * Copyright (c) 2017, Barclays Africa Technology, All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file
 */

import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { Route, Router } from '@angular/router';
import { go } from "@ngrx/router-store";
import { Effect, Actions, toPayload } from '@ngrx/effects';

import { Observable } from 'rxjs/Observable';
import '@api/rxjs-operators';

/* API actions */
import * as apiUI from '@api/store/actions/ui.actions';
import { Dashboard } from '@api/models/dashboard';

import { Experience } from '../../models/experience';

/* Threshold actions */
import * as thresholdActions from '../../store/actions/actions';

/* Threshold experience actions */
import * as thresholdExperienceActions from '../actions/experience.actions';

/* Threshold services */
import { UIEnvironmentService } from '../../services';

import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class Effects {

    constructor(
        private actions$: Actions, 
        private router: Router, 
        private uiEnvironmentService: UIEnvironmentService,
        private translateService: TranslateService,
        private store: Store<any>) {

    }

    // @Effect()
    // routeToFallback$: Observable<Action> = this.actions$
    //     .ofType(apiUI.LOAD_DASHBOARD_MENU_SUCCESS)
    //     .map(toPayload)
    //     .mergeMap(
    //         (dashboards: Dashboard[]) => (
    //             this.actions$.ofType(thresholdExperienceActions.LOAD_EXPERIENCE)
    //                 .map(toPayload)
    //                 .delay(300)
    //                 .map(
    //                     (experiences: Experience[]) => 
    //                         {   
    //                             console.log('experiences', experiences);

    //                             // We redirect to a connected experience ONLY if
    //                             // 1. User routes to the landing page
    //                             // 2. User has no default dashboards setup
    //                             // 3. User only has one active connected experience
    //                             if (((this.router.url == "/") || (this.router.url == "/id_token")) && (dashboards.length == 0) && (experiences.length == 1)) {
    //                                 return this.router.navigate([experiences[0].path]);
    //                             }

    //                             if (experiences.length == 0) {
    //                                 console.error("The application failed to initialize because required connected experience information is not available.");
    //                             }
    //                         }
    //                 )
    //         )                                
    //     )
    //     .map(data => new thresholdExperienceActions.LoadExperienceSuccessAction());

    /**
     * Set supported languages
     */
    @Effect()
    addLocalizationSupportedLanguages$: Observable<Action> = this.actions$
        .ofType(thresholdActions.SET_LOCALIZATION_SUPPORTED_LANGUAGES)
        .map(toPayload)
        .map((langs: string[]) => {            
            this.translateService.addLangs(langs);
        })
        .map(() => new thresholdActions.SetLocalizationSupportedLangsSuccessAction())

    /**
     * Set default language
     */
    @Effect()
    setLang$: Observable<Action> = this.actions$
        .ofType(thresholdActions.SET_LOCALIZATION_DEFAULT_LANGUAGE)
        .map(toPayload)
        .map(lang => {

            if (this.translateService.getLangs().indexOf(lang) === -1) {
                console.warn("Localization: Language not supported: ", lang);
            }

            this.translateService.currentLoader.getTranslation(lang).subscribe((data) => {                                                     
                this.translateService.setTranslation(lang, data, false);
                this.translateService.use(lang);
                
                // Indicate that we are done loading new translations
                this.store.dispatch(new thresholdActions.LoadingLanguageSuccessAction)
            });          
        })
        .map(() => new thresholdActions.RefreshLangAction()) 

    /**
     * Set Page (Application) Title
     */
    @Effect()
    setPageTitle$: Observable<Action> = this.actions$
        .ofType(thresholdActions.SET_APPLICATION_TITLE)
        .map(toPayload)
        .map((title: string) => this.uiEnvironmentService.setPageTitle(title))
        .map(() => new thresholdActions.SetApplicationTitleSuccessAction());

    /**
     * Search
     */
    @Effect()
    search$: Observable<Action> = this.actions$
        .ofType(thresholdActions.FETCH_SEARCH_RESULTS)
        .map(toPayload)
        .switchMap((searchPhrase: string) => this.router.navigate(["search/", searchPhrase ]))
        .map((navigationSuccess: boolean) => new thresholdActions.FetchSearchResultsSuccessAction(navigationSuccess));
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/store/effects/effects.ts